import React from 'react';

const DEFAULT_SEGMENTS = [
  { id: 'cold_open',    title: 'Cold Open' },
  { id: 'factual',      title: 'Factual Brief' },
  { id: 'challenge',    title: 'Challenge Round' },
  { id: 'expansion',    title: 'Science / Systems' },
  { id: 'prediction',   title: 'Prediction Round' },
  { id: 'close',        title: 'Close · Next Watch' },
];

export default function RundownTimeline({ segments, activeIdx }) {
  const source = (segments && segments.length > 0) ? segments : DEFAULT_SEGMENTS;
  return (
    <div className="studio-bottom" data-testid="rundown-timeline">
      {source.map((s, idx) => {
        const isCurrent = idx === activeIdx;
        const isDone = idx < activeIdx;
        const title = s.title || s.name || s.segment || s.id || `Segment ${idx + 1}`;
        const speaker = s.speaker ? String(s.speaker).toUpperCase() : '';
        return (
          <div
            key={s.id || idx}
            className={`rundown-seg ${isCurrent ? 'is-current' : ''} ${isDone ? 'is-done' : ''}`}
            data-testid={`rundown-seg-${idx}`}
          >
            <span className="order">{String(idx + 1).padStart(2, '0')}</span>
            <span>{title}</span>
            {speaker && <span style={{ fontSize: 10, color: 'var(--studio-text-2)' }}>{speaker}</span>}
          </div>
        );
      })}
    </div>
  );
}
